import * as Sentry from "@sentry/react";
import { useEffect } from "react";

const useSentryReplayHook = () => {
  useEffect(() => {
    const client = Sentry.getCurrentHub().getClient();

    // Check if Replay integration already exists to prevent multiple instances
    const existingReplay = client.getIntegrationByName("Replay");
    if (existingReplay) {
      return; // Already initialized, don't add another
    }

    client.addIntegration(
      new Sentry.Replay({
        maskAllText: true,
        blockAllMedia: true,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1,
      })
    );
  }, []);
};

export default useSentryReplayHook;
